import React from "react";

import { AdminSection, Button, Col, Form, Icon, Input, InputNumber, Option, Row, Select } from "components";

export const ModuleDetails = ({ module, icons }) => (
  <>
    <Row>
      <Col>
        <Input name="name" label="Module name" rules={[{ required: true, message: false }]} initialValue={module && module.name} />
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={12}>
        <Select
          name="icon"
          label="Select icon"
          initialValue={module.icon}
          showSearch
          optionFilterProp="children"
          filterOption={(input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0}
          optionLabelProp={"label"}
          rules={[{ required: true, message: false }]}
        >
          {icons.map((icon, i) => (
            <Option value={icon} label={icon} key={i}>
              <Icon iconName={icon} size="s" className="icon inline" /> ({icon})
            </Option>
          ))}
        </Select>
      </Col>
      <Col sm={24} md={12}>
        <InputNumber name="priority" label="Priority" rules={[{ required: true, message: false }]} initialValue={module && module.priority} />
      </Col>
    </Row>
    <Row>
      <Col sm={24} md={8}>
        <Select name="recommended" label="Recommended" rules={[{ required: true, message: false }]} initialValue={module && module.recommended}>
          <Option value={true}>Yes</Option>
          <Option value={false}>No</Option>
        </Select>
      </Col>
      <Col sm={24} md={8}>
        <Select name="enabled" label="Enabled" rules={[{ required: true, message: false }]} initialValue={module && module.enabled}>
          <Option value={true}>Yes</Option>
          <Option value={false}>No</Option>
        </Select>
      </Col>
      <Col sm={24} md={8}>
        <Select name="beta" label="Beta" rules={[{ required: true, message: false }]} initialValue={module && module.beta}>
          <Option value={true}>Yes</Option>
          <Option value={false}>No</Option>
        </Select>
      </Col>
    </Row>

    <AdminSection
      headline="Module selector parameters"
      description="These are the module specific parameters for the module selector. Global parameters can be found in the general module settings."
    />
    <Row>
      <Col>
        <p>{"Average earnings/ha"}</p>
        <InputNumber name="averageEarnings" label="Average earnings" initialValue={module && module.averageEarnings} suffix={"€/ha"} />
      </Col>
      <Col>
        <p>Farm benefits</p>
        <p>{`Update the Farm benefits in crowdin under: ${`modules.${module.module}.farmBenefits`}`} </p>
      </Col>
      <Col>
        <p>Data to provide</p>
        <p>{`Update the Data to provide in crowdin under: ${`modules.${module.module}.selectorDescription`}`} </p>
      </Col>
    </Row>
    <Row>
      <Col>
        <p>Measures</p>
        <p>{`Update the Measures in crowdin under: ${`modules.${module.module}.measures`}`} </p>
      </Col>
    </Row>

    <Row>
      <Col>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Save module
          </Button>
        </Form.Item>
      </Col>
    </Row>
  </>
);
